export default "__VITE_ASSET__DZBZj$Wz__"